import { createUseStyles, ComposedTheme } from '@glu/theming';
import { IIconProps } from './Icon';

type TIconStylesProps = Pick<IIconProps, 'fill' | 'height' | 'width'>;

const styles = ({ icons }: ComposedTheme) => ({
  icon: {
    display: 'block',
    fill: ({ fill }: TIconStylesProps) => fill || icons.fill,
    height: ({ height }: TIconStylesProps) => height || icons.size,
    width: ({ width }: TIconStylesProps) => width || icons.size,
    '&:before': { content: 'none' },
  },
  iconWrapper: {
    display: 'inline-block',
  },
});

export default createUseStyles(styles);
